import update from 'immutability-helper';
import * as actionTypes from '../actionTypes';

const DefaultState = {
    selectTab:0,
    hoverSelectTab: -1,
};


const ChangeChooseListManagerProperty = (state: IDefaultState = DefaultState, action) => {
    let { propertyName, payload: { data } } = action;

    return update(state, {
        [propertyName]: { $set: data }
    });
}



export type IDefaultState = typeof DefaultState;


export default (state: IDefaultState = DefaultState, action) => {

    switch (action.type) {
        case actionTypes.CHANGE_CHOOSE_LIST_MANAGER_PROPERTY:
            return ChangeChooseListManagerProperty(state, action);

        default:
            return state;
    }

}